<template>
  <div>
    <Head :title="`${$t('treatments.treatment')} #${data.id}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/view`">
        {{ data.applicant_details.id }}. {{ data.applicant_details.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.id}/view`">
        {{ data.treatment_type_name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('global.update') }}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore">
      {{ $t('applicants.trashed_message') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form" :treatment_types="treatment_types" :statuses="statuses" />
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
<!--          <button-->
<!--            v-if="!data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"-->
<!--            @click="destroy"-->
<!--          >-->
<!--            {{ $t('global.delete') }}-->
<!--          </button>-->
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Icon from '@/Shared/Icon'
import Form from '@/Pages/Treatments/Form'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
    Icon,
    Form,
  },
  layout: Layout,
  props: {
    data: Object,
    treatment_types: Object,
    statuses: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        reason_closed: this.data.reason_closed,
        treatment_type_id: this.data.treatment_type_id,
        volunteer_name: this.data.volunteer_name,
        status: this.data.status.value,
        date_open: this.data.date_open,
        date_closed: this.data.date_closed,
        paper_file: this.data.paper_file,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/applicants/${this.data.applicant_id}/treatments/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/applicants/${this.data.applicant_id}/treatments/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/applicants/${this.data.applicant_id}/treatments/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
